import { render, staticRenderFns } from "./ScreenConfigureRooms.vue?vue&type=template&id=0595332d&scoped=true"
import script from "./ScreenConfigureRooms.vue?vue&type=script&lang=js"
export * from "./ScreenConfigureRooms.vue?vue&type=script&lang=js"
import style0 from "./ScreenConfigureRooms.vue?vue&type=style&index=0&id=0595332d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0595332d",
  null
  
)

export default component.exports